import A11yDialog from 'a11y-dialog';

window.A11yDialog = A11yDialog;
